module.exports = __webpack_public_path__ + "images/drawings/sun_yellow.272ba625de88a4970ef2f7010eea1342.png";